import { Query, QueryOptions } from 'types'
import { logFactory } from 'utils'
import { usePartners, usePartnerEmployeePartnerShops } from 'hooks'

const hookName = 'useResource'
const log = logFactory(hookName)

type UsePrimaryPartnerShopProps = Query<{
  accountId: string
}>

const usePrimaryPartnerShop = (
  { accountId }: UsePrimaryPartnerShopProps,
  options: QueryOptions = { enabled: true }
) => {
  log(`🥼 Fetching partner employees for account `, accountId)
  const { data: partnerEmployees } = usePartners(
    {
      id: accountId,
    },
    options
  )
  const [partnerEmployee] = partnerEmployees ?? []
  const {
    data: partnerShops = [],
    isLoading: isPartnerEmployeePartnerShopsLoading,
    isError: isPartnerEmployeePartnerShopsError,
  } = usePartnerEmployeePartnerShops(
    { gid: partnerEmployee?.gid as string, isPrimaryShop: true },
    { enabled: Boolean(partnerEmployee?.gid), ...options }
  )
  const [primaryPartnerShop] = partnerShops

  log(`🥼 Returned primary partner shop `, primaryPartnerShop?.salesforceId)

  return {
    isError: isPartnerEmployeePartnerShopsError,
    isLoading: isPartnerEmployeePartnerShopsLoading,
    primaryPartnerShop,
  }
}

export { usePrimaryPartnerShop }
